import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { Container as MyNewsContainer } from "~/components/header/header-my-news/styles";
import { MenuItem } from "~/components/header/header-oneline-menu-container/header-oneline-menu/styles";
import { Divider as OnelineMenuDivider } from "~/components/header/header-oneline-menu-container/styles";
import {
  ActionButton,
  Container as HeaderContainer,
  StyledLogoText,
} from "~/components/header/styles";
import {
  setFullViewportWidthBackgroundStyles,
  setFullViewportWidthStyles,
  ZIndexLayer,
} from "~/lib/styles";
import type { ResponsiveVariants } from "~/lib/styles/responsive";
import { setResponsiveVariantStyles } from "~/lib/styles/responsive";

import type { AppBarTheme } from "./helpers";

export const FullWidthBackground = styled.div`
  ${setFullViewportWidthBackgroundStyles("#ffffff")}
`;

type AppBarContainerProps = {
  $appBarTheme?: AppBarTheme;
};

export const Container = styled.header<AppBarContainerProps>`
  inset-block-start: 0;
  z-index: ${ZIndexLayer.AppBar};

  ${props => {
    if (props.$appBarTheme === "dark") {
      return css`
        ${FullWidthBackground}, ${HeaderContainer} {
          background-color: #000000;
        }

        ${OnelineMenuDivider}, ${MenuItem} {
          color: #ffffff;
        }

        ${MyNewsContainer} {
          border-color: rgba(255, 255, 255, 0.4);
        }

        ${ActionButton} svg path, ${StyledLogoText} path {
          fill: #ffffff;
        }
      `;
    }
  }}
`;

type AdSlotProps = {
  $responsiveVariants: ResponsiveVariants<{
    $height: number;
    $isVisible?: boolean;
    $padding: number;
  }>;
};

export const AdSlotContainer = styled.div<AdSlotProps>`
  ${setFullViewportWidthStyles()}
  box-sizing: content-box;

  background-color: #f6f6f6;
  ${props =>
    setResponsiveVariantStyles(
      props.$responsiveVariants,
      variant => css`
        display: ${variant.$isVisible ? "block" : "none"};

        block-size: ${`${variant.$height}px`};
        padding-block: ${`${variant.$padding}px`};
      `,
    )}
`;
